import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(apiErr(err)); } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="forgot-page">
      <div className="w-full max-w-sm">
        <Logo size={34} />
        <h1 className="font-heading font-bold text-2xl tracking-tight mt-8">Forgot your password?</h1>
        {sent ? (
          <p className="text-sm text-muted-foreground mt-3" data-testid="forgot-sent">If an account exists for {email}, we've emailed a reset link. Check your inbox.</p>
        ) : (
          <>
            <p className="text-sm text-muted-foreground mt-1">Enter your email and we'll send a reset link.</p>
            <form onSubmit={submit} className="space-y-4 mt-6">
              <div><Label htmlFor="email">Email</Label><Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" data-testid="forgot-email-input" /></div>
              <Button type="submit" disabled={loading} className="w-full h-11 brand-gradient text-white border-0" data-testid="forgot-submit-btn">{loading ? "Sending..." : "Send reset link"}</Button>
            </form>
          </>
        )}
        <p className="text-sm text-muted-foreground mt-6 text-center"><Link to="/login" className="text-primary hover:underline">Back to login</Link></p>
      </div>
    </div>
  );
}
